import { useSelector } from 'react-redux'
import { useQuery } from 'react-query'
import { useAuth0 } from '../../../contexts/auth0-context'
import endpoints from '../../../API/endpoints'
import callAPI from '../../../API/callSecureAPI'
import { Activity } from '../useGetActivitiesQuery'

const FIVE_MINUTES = 1000 * 60 * 5

type ActivityByFunctionMetricsData = {
    grouping: string
    items: Record<string, Activity[]>
}

// @TODO metrics - invalidate all metrics queries on vm/evidence/activity delete?
export const useGetActivityByFunctionQuery = () => {
    const { getTokenSilently, isAuthenticated, isLoading } = useAuth0()

    // @ts-expect-error store is not typed properly
    const strategyId = useSelector((state) => state.strategy?._id)

    const getActivityByFunction = async () => {
        try {
            const token = await getTokenSilently?.({ audience: 'https://atlas.aesara.com' })

            const { url, method } = endpoints.getActivityByFunction

            const response = await callAPI(url + strategyId, method, token)

            return response.data as ActivityByFunctionMetricsData[]
        } catch (e) {
            console.log(e)
        }
    }

    return useQuery<ActivityByFunctionMetricsData[]>(['activityByFunction', strategyId], getActivityByFunction, {
        enabled: !!getTokenSilently && !!isAuthenticated && !isLoading && !!strategyId,
        cacheTime: FIVE_MINUTES,
        staleTime: FIVE_MINUTES,
        retry: 3,
    })
}
